import { combineReducers } from 'redux';
import settingsReducer from './settings/reducer';
import channelReducer from './channel/reducer';
import queryByStoreReducer from './query-by-store/reducer';
import organizationUnitsReducer from './organizationUnits/reducer';
import libraryReducer from './library/reducer';
import countriesReducer from './countries/reducer';
import statesReducer from './states/reducer';
import websitesReducer from './websites/reducer';
import themeReducer from './theme/reducer';
import websiteCardsReducer from './websiteCards/reducer';
import userProfileReducer from './userProfile/reducer';
import bookingsReducer from './bookings/reducer';
import leadsReducer from './leads/reducer';
import agentsReducer from './agents/reducer';
import regionsReducer from './route-management/regions/reducer';
import routesReducer from './route-management/routes/reducer';
import routePointsReducer from './route-management/route-points/reducer';
import zonesReducer from './zones/reducer';
import rateCardsReducer from './rate-cards/reducer';
import cmsSettingsReducer from './cmsSettings/reducer';
import ordersReducer from './orders/reducer';
import quotesReducer from './quotes/reducer';
import razorpayReducer from './razporpay/reducer';
import addPaymentReducer from './addPayment/reducer';
import shippingTypesReducer from './shippingTypes/reducer';
import transportersReducer from './transporters/reducer';
import vehiclesReducer from './vehicles/reducer';
import categoriesReducer from './categories/reducer';
import productTypesReducer from './product-types/reducer';
import productsReducer from './products/reducer';
import variantsReducer from './variants/reducer';
import serviceabilitiesReducer from './serviceabilities/reducer';
import assistanceProgramsReducer from './assistance-programs/reducer';
import socialProfilesReducer from './social-profiles/reducer';
import blogPostsReducer from './blog-posts/reducer';
import blogRequestsReducer from './blog-requests/reducer';
import ticketsReducer from './tickets/reducer';
import employeesReducer from './employees/reducer';
import departmentsReducer from './departments/reducer';
import payrollsReducer from './payrolls/reducer';
import designationsReducer from './designations/reducer';
import websiteReducer from './website/reducer';
import taxLedgersReducer from './tax-ledgers/reducer';
import taxProvidersReducer from './tax-providers/reducer';
import taxSettingsReducer from './tax-settings/reducer';
import payoutsReducer from './payouts/reducer';
import termsLibrariesReducer from './terms-libraries/reducer';
import sectionsReducer from './sections/reducer';
import branchesReducer from './branches/reducer';
import storesReducer from './stores/reducer';
import productionPlantsReducer from './production-plants/reducer';
import warehousesReducer from './ware-houses/reducer';
import locationsReducer from './locations/reducer';
import usersReducer from './users/reducer';
import rolesReducer from './roles/reducer';
import accessControlsReducer from './access-controls/reducer';
import pagesReducer from './pages/reducer';
import accountsReducer from './accounts/reducer';
import accountTypesReducer from './account-types/reducer';
import contactsReducer from './contacts/reducer';
import languagesReducer from './languages/reducer';
import currenciesReducer from './currencies/reducer';
import membershipsReducer from './memberships/reducer';
import membershipTypesReducer from './membership-types/reducer';
import membershipMemberMappingsReducer from './membership-member-mappings/reducer';
import dbnpReducer from './dbnp/reducer';
import dbnpMappingsReducer from './dbnp-mappings/reducer';
import orgRegistriesReducer from './org-registries/reducer';
import emailAccountsReducer from './email-accounts/reducer';
import paymentMethodsReducer from './payment-methods/reducer';
import batchLogsReducer from './batch-logs/reducer';
import logsReducer from './logs/reducer';
import systemInformationsReducer from './system-informations/reducer';
import ParsingRulesReducer from './parsing-rules/reducer';
import customersReducer from './customers/reducer';
import jobsReducer from './jobs/reducer';
import tasksReducer from './tasks/reducer';
import userReducer from './user/reducer';
import organizationsReducer from './organizations/reducer';
import addressBooksReducer from './address-books/reducer';
import timeZonesReducer from './time-zone/reducer';
import uploadFilesReducer from './upload-files/reducer';
import productionUnitsReducer from './production-units/reducer';
import collectionPointsReducer from './collection-points/reducer';
import servicesReducer from './services/reducer';
import globalsReducer from './global/reducer';
import eApplicationsReducer from './e-applications/reducer';
import deliveryDatesReducer from './delivery-dates/reducer';
import measureDimensionsReducer from './measure-dimensions/reducer';
import measureWeightsReducer from './measure-weights/reducer';
import taxCategoriesReducer from './tax-categories/reducer';
import cancelReasonsReducer from './cancel-reasons/reducer';
import fulfillmentProvidersReducer from './fulfillment-providers/reducer';
import shippingProvidersReducer from './shipping-providers/reducer';
import tenantDomainsReducer from './tenant-domains/reducer';
import tagsReducer from './tags/reducer';
import vendorsReducer from './vendors/reducer';
import pinCodesReducer from './pin-codes/reducer';
import pickupPointsReducer from './pickup-points/reducer';
import networksReducer from './dbaas/networks/reducer';
import pushNotificationsReducer from './push-notification/reducer';
import shippingModesReducer from './logistics/transport/shipping-modes/reducer';
import blogPostFilesReducer from './blog-post-files/reducer';
import newsletterReducer from './news-letters/reducer';
import newsletterFilesReducer from './news-letters-files/reducer';
import announcementsReducer from './announcements/reducer';
import helpTopicFilesReducer from './help-topics-files/reducer';
import helpTopicsReducer from './help-topics/reducer';
import influencersReducer from './influencers/reducer';
import { tenantFunctions } from './tenant-functions/action';
import tenantFunctionsReducer from './tenant-functions/reducer';
import edocsReducer from './e-docs/reducer';
import templatesReducer from './templates/reducer';
import agentLocationTrackersReducer from './agent-location-tracker/reducer';
import externalAuthenticationsReducer from './external-authentications/reducer';
import scheduledTasksReducer from './scheduled-tasks/reducer';
import convertFileReducer from './convert-file/reducer';
import ticketActivitiesReducer from './ticket-activities/reducer';
import serviceRequestsReducer from './service-requests/reducer';
import evaluationsReducer from './evaluations/reducer';
import projectsReducer from './projects/reducer';
import cascadedAccountsReducer from './cascaded-account/reducer';
import packageSettingsReducer from './package-settings/reducer';
import catalogSettingsReducer from './catalog-settings/reducer';
import crmSettingsReducer from './crm-settings/reducer';
import domSettingsReducer from './dom-settings/reducer';
import eApplicationSettingsReducer from './e-applications-setting/reducer';
import eProcurementsReducer from './e-procurements/reducer';
import globalSettingsReducer from './global-settings/reducer';
import marketingsReducer from './marketings/reducer';
import organizationSettingsReducer from './organizations-setting/reducer';
import productionsReducer from './productions/reducer';
import transporterSettingsReducer from './transporter-setting/reducer';
import cargoLeadsReducer from './cargo-lead/reducer';
import cargoQuotesReducer from './cargo-quotes/reducer';
import tripsReducer from './trips/reducer';
import agentStatusReducer from './agent-status/reducer';
import brandMappingsReducer from './brand-mappings/reducer';
import accountLedgersReducer from './account-ledgers/reducer';
import accountCategoriesReducer from './account-categories/reducer';
import accountUsersReducer from './account-users/reducer';
import rewardPointsReducer from './policy/merchandising/reward-points/reducer';
import paymentStatusReducer from './payment-status/reducer';
import metaTokensReducer from './meta-token/reducer';
import globalOrgRegistryMappingsReducer from './global-org-registry-mappings/reducer';
import globalDBNPRegistrationsReducer from './global-dbnp-registrations/reducer';
import globalOrgRegistrationsReducer from './global-org-registrations/reducer';
import opennetworkDomainsReducer from './opennetwork-domains/reducer';
import dbnpRegistriesReducer from './dbnp-registries/reducer';
import accountWebPagesReducer from './web-pages/reducer';
import bankAccountsReducer from './fms/bank-accounts/reducer';
import budgetsReducer from './fms/budgets/reducer';
import contrasReducer from './fms/contras/reducer';
import financialYearsReducer from './fms/financial-years/reducer';
import journalsReducer from './fms/journals/reducer';
import receiptsReducer from './fms/receipts/reducer';
import vouchersReducer from './fms/vouchers/reducer';
import grnsReducer from './grns/reducer';
import bankConfigurationsReducer from './bank-configurations/reducer';
import suppliersReducer from './suppliers/reducer';
import lmsCollectionsReducer from './lms/collections/reducer';
import lmsChaptersReducer from './lms/collections/chapters/reducer';
import lmsModulesReducer from './lms/modules/reducer';
import lmsCoursesReducer from './lms/courses/reducer';
import lmsLearningPathsReducer from './lms/learning-path/reducer';
import lmsTopicsReducer from './lms/topics/reducer';
import lmsCertificatesReducer from './lms/certificates/reducer';
import lmsCertifiedUsersReducer from './lms/certified-users/reducer';
import dbsBankReducer from './e-pay/e-bankings/dbs/reducer';
import ccAvenuesReducer from './e-pay/payment-gateways/cc-avenues/reducer';
import phonePeReducer from './e-pay/payment-gateways/phone-pe/reducer';
import razorpaysReducer from './e-pay/payment-gateways/razorpays/reducer';
import paymentHistoriesReducer from './e-pay/payment-history/reducer';
import paymentTransactionsReducer from './e-pay/payment-transactions/reducer';
import reconciliationItemsReducer from './settlement-hub/reconciliation-items/reducer';
import reconciliationRequestItemsReducer from './settlement-hub/reconciliation-request-items/reducer';
import reconRequestsReducer from './settlement-hub/reconciliation-requests/reducer';
import reconciliationsReducer from './settlement-hub/reconciliations/reducer';
import settlementItemsReducer from './settlement-hub/settlement-items/reducer';
import settlementPayoutsReducer from './settlement-hub/settlement-payouts/reducer';
import settlementRequestItemsReducer from './settlement-hub/settlement-request-items/reducer';
import settlementRequestsReducer from './settlement-hub/settlement-requests/reducer';
import settlementsReducer from './settlement-hub/settlements/reducer';
import accountTransactionsReducer from './account-transactions/reducer';
import creditDebitNotesReducer from './credit-debit-notes/reducer';
import stockTransfersReducer from './stock-transfers/reducer';
import opennetworkCategoriesReducer from './opennetwork-categories/reducer';
import tenantOpenNetworkDomainsReducer from './tenant-open-network-domains/reducer';
import tenantOpenNetworkCategoriesReducer from './tenant-open-network-categories/reducer';
import opennetworkLogsReducer from './open-network-logs/reducer';
import dbnCategoryProductMappingsReducer from './dbn-category-product-mappings/reducer';
import dbnDomainAccountMappingsReducer from './dbn-domain-account-mappings/reducer';
import dbnCategoryAccountMappingsReducer from './dbn-category-account-mappings/reducer';
import agentnetTypesReducer from './agentnet-types/reducer';
import dbnAgentsReducer from './dbn-agents/reducer';
import biznetTypesReducer from './biznet-types/reducer';
import dbaasSubscriptionsReducer from './dbaas-subscriptions/reducer';
import dbaTypesReducer from './dba-types/reducer';
import dbaCatalogsReducer from './dba-catalogs/reducer';
import subscriptionsReducer from './subscriptions/reducer';
import gatewayRegistriesReducer from './gateway-registries/reducer';
import gatewaysReducer from './gateways/reducer';
import dbasReducer from './dbas/reducer';
import dbnieReducer from './dbnie/reducer';
import programsReducer from './programs/reducer';
import globalDBNAgentMappingsReducer from './global-DBN-Agent-mappings/reducer';
import policyCollectionsReducer from './organization/collections/reducer';
import globalCatalogReducer from './global-catalog/reducer';
import logisticsSettingsReducer from './logistics-settings/reducer';
import logisticsConfigurationsReducer from './logistics-Configurations/reducer';
import vehicleCategoriesReducer from './vehicle-categories/reducer';
import smsConfigurationsReducer from './sms-configuration/reducer';
import applicationReducer from './applications/reducer';
import digitalPrivateInfrastructureReducer from './digital-private-infrastructures/reducer';
import digitalPublicInfrastructureReducer from './digital-public-infrastructures/reducer';
import endpointReducer from './endpoints/reducer';
import environmentReducer from './environments/reducer';
import phasesReducer from './phases/reducer';
import sectionTemplatesReducer from './section-templates/reducer';
import discountsReducer from './policy/merchandising/discounts/reducer';
import tierPricesReducer from './policy/pricing/tier-prices/reducer';
import deliveriesReducer from './policy/shipment/deliveries/reducer';
import shipmentsReducer from './shipments/reducer';
import returnRequestsReducer from './return-requests/reducer';
import dbaDBNBIZMappingsReducer from './dba-dbn-biz-mappings/reducer';
import dbaDiscountMappingsReducer from './dba-discount-mappings/reducer';
import dbaCollectionMappingsReducer from './dba-collection-mappings/reducer';
import EsbAuditLogReducer from './esb-audit-logs/reducer';
import SheduleAuditLogsReducer from './schedule-audit-logs/reducer';
import shipxAgencyMappingsReducer from './shipx-agency-mappings/reducer';
import dbaRegistriesReducer from './dba-registries/reducer';
import dbapartnerAgencyMappingsReducer from './dba-partner-agency-mappings/reducer';
import globalDBARegistriesReducer from './global-dba-registries/reducer';
import channelProgramsReducer from './channel-program/reducer';
import dodProgramParticipantReducer from './dod-program-participants/reducer';
import logisticsOrdersReducer from './logistics-orders/reducer';
import stopsReducer from './stops/reducer';
import shipmentReducer from './shipment/reducer';
import journeyReducer from './journey/reducer';
import journeyLegReducer from './journeyLeg/reducer';


const appReducer = combineReducers({
	// Shipx related reducer
	shipxAgencyMappings: shipxAgencyMappingsReducer,
	dbaRegistries: dbaRegistriesReducer,
	dbaPartnerAgencyMappings: dbapartnerAgencyMappingsReducer,
	globalDBARegistries: globalDBARegistriesReducer,
	channelPrograms: channelProgramsReducer,
	dodProgramParticipants: dodProgramParticipantReducer,
	logisticsOrders: logisticsOrdersReducer,
	//
	applications: applicationReducer,
	digitalPrivateInfrastructures: digitalPrivateInfrastructureReducer,
	digitalPublicInfrastructures: digitalPublicInfrastructureReducer,
	endpoints: endpointReducer,
	environments: environmentReducer,
	phases: phasesReducer,
	// DBN Related reducer
	globalCatalog: globalCatalogReducer,
	policyCollections: policyCollectionsReducer,
	globalDBNAgentMappings: globalDBNAgentMappingsReducer,
	opennetworkCategories: opennetworkCategoriesReducer,
	tenantOpenNetworkDomains: tenantOpenNetworkDomainsReducer,
	tenantOpenNetworkCategories: tenantOpenNetworkCategoriesReducer,
	opennetworkLogs: opennetworkLogsReducer,
	dbnCategoryProductMappings: dbnCategoryProductMappingsReducer,
	dbnDomainAccountMappings: dbnDomainAccountMappingsReducer,
	dbnCategoryAccountMappings: dbnCategoryAccountMappingsReducer,
	agentnetTypes: agentnetTypesReducer,
	dbnAgents: dbnAgentsReducer,
	biznetTypes: biznetTypesReducer,
	dbnie: dbnieReducer,
	dbaasSubscriptions: dbaasSubscriptionsReducer,
	dbaTypes: dbaTypesReducer,
	dbaCatalogs: dbaCatalogsReducer,
	programs: programsReducer,
	subscriptions: subscriptionsReducer,
	gatewayRegistries: gatewayRegistriesReducer,
	gateways: gatewaysReducer,
	dbas: dbasReducer,
	shipments: shipmentsReducer,
	returnRequests: returnRequestsReducer,
	dbaDBNBIZMappings: dbaDBNBIZMappingsReducer,
	dbaDiscountMappings: dbaDiscountMappingsReducer,
	dbaCollectionMappings: dbaCollectionMappingsReducer,

	theme: themeReducer,
	user: userReducer,
	channel: channelReducer,
	uploadFiles: uploadFilesReducer,
	queryByStore: queryByStoreReducer,
	organizationUnits: organizationUnitsReducer,
	library: libraryReducer,
	countries: countriesReducer,
	states: statesReducer,
	addressBooks: addressBooksReducer,
	websites: websitesReducer,
	websiteCards: websiteCardsReducer,
	userProfile: userProfileReducer,
	bookings: bookingsReducer,
	leads: leadsReducer,
	quotes: quotesReducer,
	orders: ordersReducer,
	agents: agentsReducer,
	agentLocationTrackers: agentLocationTrackersReducer,

	//Route Management Start
	regions: regionsReducer,
	routes: routesReducer,
	routePoints: routePointsReducer,
	zones: zonesReducer,
	//Route Management End

	rateCards: rateCardsReducer,
	razporpay: razorpayReducer,
	addPayment: addPaymentReducer,
	shippingTypes: shippingTypesReducer,
	transporters: transportersReducer,
	vehicles: vehiclesReducer,
	vehicleCategories: vehicleCategoriesReducer,
	categories: categoriesReducer,
	productTypes: productTypesReducer,
	products: productsReducer,
	variants: variantsReducer,
	serviceabilities: serviceabilitiesReducer,
	assistancePrograms: assistanceProgramsReducer,
	stops: stopsReducer,
	//CMS Start
	tenantFunctions: tenantFunctionsReducer,
	eDocs: edocsReducer,
	templates: templatesReducer,
	socialProfiles: socialProfilesReducer,
	blogPosts: blogPostsReducer,
	blogPostsFiles: blogPostFilesReducer,
	newsletters: newsletterReducer,
	newsletterFiles: newsletterFilesReducer,
	blogRequests: blogRequestsReducer,
	influencers: influencersReducer,
	helpTopics: helpTopicsReducer,
	announcements: announcementsReducer,
	helpTopicsFiles: helpTopicFilesReducer,
	sectionTemplates: sectionTemplatesReducer,
	//CMS End

	tickets: ticketsReducer,
	ticketActivities: ticketActivitiesReducer,

	// e-applications start
	employees: employeesReducer,
	departments: departmentsReducer,
	payrolls: payrollsReducer,
	designations: designationsReducer,
	website: websiteReducer,
	accountTransactions: accountTransactionsReducer,
	creditDebitNotes: creditDebitNotesReducer,
	taxLedgers: taxLedgersReducer,
	taxProviders: taxProvidersReducer,

	bankAccounts: bankAccountsReducer,
	budgets: budgetsReducer,
	contras: contrasReducer,
	financialYears: financialYearsReducer,
	journals: journalsReducer,
	receipts: receiptsReducer,
	vouchers: vouchersReducer,
	payouts: payoutsReducer,
	termsLibraries: termsLibrariesReducer,
	sections: sectionsReducer,
	//eApplications - LMS
	lmsCollections: lmsCollectionsReducer,
	lmsChapters: lmsChaptersReducer,
	lmsModules: lmsModulesReducer,
	lmsCourses: lmsCoursesReducer,
	lmsLearningPaths: lmsLearningPathsReducer,
	lmsTopics: lmsTopicsReducer,
	lmsCertificates: lmsCertificatesReducer,
	lmsCertifiedUsers: lmsCertifiedUsersReducer,
	// e-application e-pay
	dbsBank: dbsBankReducer,
	ccAvenues: ccAvenuesReducer,
	phonePe: phonePeReducer,
	razorpays: razorpaysReducer,
	paymentHistories: paymentHistoriesReducer,
	paymentTransactions: paymentTransactionsReducer,
	// e-application settlement hub
	reconciliationItems: reconciliationItemsReducer,
	reconciliationRequestItems: reconciliationRequestItemsReducer,
	reconciliationRequests: reconRequestsReducer,
	reconciliations: reconciliationsReducer,
	settlementItems: settlementItemsReducer,
	settlementPayouts: settlementPayoutsReducer,
	settlementRequestItems: settlementRequestItemsReducer,
	settlementRequests: settlementRequestsReducer,
	settlements: settlementsReducer,
	// e-applications end

	// stock control
	stockTransfers: stockTransfersReducer,
	branches: branchesReducer,
	stores: storesReducer,
	productionPlants: productionPlantsReducer,
	warehouses: warehousesReducer,
	locations: locationsReducer,
	users: usersReducer,
	roles: rolesReducer,
	externalAuthentications: externalAuthenticationsReducer,
	accessControls: accessControlsReducer,
	pages: pagesReducer,
	accounts: accountsReducer,
	accountTypes: accountTypesReducer,
	contacts: contactsReducer,
	languages: languagesReducer,
	currencies: currenciesReducer,
	memberships: membershipsReducer,
	membershipTypes: membershipTypesReducer,
	membershipMemberMappings: membershipMemberMappingsReducer,
	dbnp: dbnpReducer,
	dbnpMappings: dbnpMappingsReducer,
	orgRegistries: orgRegistriesReducer,
	opennetworkDomains: opennetworkDomainsReducer,
	globalOrgRegistryMappings: globalOrgRegistryMappingsReducer,
	globalDBNPRegistrations: globalDBNPRegistrationsReducer,
	globalOrgRegistrations: globalOrgRegistrationsReducer,
	dbnpRegistries: dbnpRegistriesReducer,
	emailAccounts: emailAccountsReducer,
	paymentMethods: paymentMethodsReducer,
	batchLogs: batchLogsReducer,
	logs: logsReducer,
	systemInformations: systemInformationsReducer,
	parsingRules: ParsingRulesReducer,
	customers: customersReducer,
	jobs: jobsReducer,
	tasks: tasksReducer,
	organizations: organizationsReducer,
	timeZones: timeZonesReducer,
	collectionPoints: collectionPointsReducer,
	productionUnits: productionUnitsReducer,
	services: servicesReducer,
	globals: globalsReducer,
	eApplications: eApplicationsReducer,
	deliveryDates: deliveryDatesReducer,
	measureDimensions: measureDimensionsReducer,
	measureWeights: measureWeightsReducer,
	taxCategories: taxCategoriesReducer,
	fulfillmentProviders: fulfillmentProvidersReducer,
	shippingProviders: shippingProvidersReducer,
	tenantDomains: tenantDomainsReducer,
	cancelReasons: cancelReasonsReducer,
	tags: tagsReducer,
	vendors: vendorsReducer,
	pinCodes: pinCodesReducer,
	pickupPoints: pickupPointsReducer,
	networks: networksReducer,
	pushNotifications: pushNotificationsReducer,
	shippingModes: shippingModesReducer,
	scheduledTasks: scheduledTasksReducer,
	convertFile: convertFileReducer,
	serviceRequests: serviceRequestsReducer,
	evaluations: evaluationsReducer,
	projects: projectsReducer,
	cascadedAccounts: cascadedAccountsReducer,
	eProcurements: eProcurementsReducer,
	marketings: marketingsReducer,
	productions: productionsReducer,
	cargoLeads: cargoLeadsReducer,
	cargoQuotes: cargoQuotesReducer,
	trips: tripsReducer,
	agentStatus: agentStatusReducer,
	brandMappings: brandMappingsReducer,
	accountLedgers: accountLedgersReducer,
	accountCategories: accountCategoriesReducer,
	accountUsers: accountUsersReducer,
	rewardPoints: rewardPointsReducer,
	deliveries: deliveriesReducer,
	tierPrices: tierPricesReducer,
	discounts: discountsReducer,
	paymentStatus: paymentStatusReducer,
	metaTokens: metaTokensReducer,
	accountWebPages: accountWebPagesReducer,
	grns: grnsReducer,
	bankConfigurations: bankConfigurationsReducer,
	suppliers: suppliersReducer,
	shipment:shipmentReducer,
	journey: journeyReducer,
	journeyLeg: journeyLegReducer,

	// Settings
	catalogSettings: catalogSettingsReducer,
	crmSettings: crmSettingsReducer,
	domSettings: domSettingsReducer,
	eApplicationSettings: eApplicationSettingsReducer,
	globalSettings: globalSettingsReducer,
	transporterSettings: transporterSettingsReducer,
	organizationSettings: organizationSettingsReducer,
	taxSettings: taxSettingsReducer,
	settings: settingsReducer,
	packageSettings: packageSettingsReducer,
	cmsSettings: cmsSettingsReducer,
	logisticsSettings: logisticsSettingsReducer,

	//Configuration
	logisticsConfigurations: logisticsConfigurationsReducer,
	smsConfigurations: smsConfigurationsReducer,
	esbAuditLog: EsbAuditLogReducer,
	sheduleAuditLogs: SheduleAuditLogsReducer,


});

const rootReducer = (state: any, action: any) => {

	return appReducer(state, action);
};

export default rootReducer;
